<template>
  <div class="flex w-full items-center gap-1 py-4">
    <div class="text-lg font-semibold text-gray-900">
      {{ review.entity?.value?.project?.name }}
      /
    </div>
    <div class="text-base font-normal text-gray-500">
      {{ review.entity?.value?.reviewSeries?.name }}
    </div>
  </div>
</template>
<script lang="ts" setup>
import { ReviewKey } from "../use-review";
import { injectStrict } from "@app/utils/injectStrict";

const review = injectStrict(ReviewKey);
</script>
